import { api } from './api';

// One fetch of the home summary behind Home and all three artifact dashboards.
//
// Why this exists, measured on 2026-08-03: clicking a dashboard took 4-6 seconds. Every one of the
// four screens called get_home_summary independently, the effect double-invokes in development so
// each navigation fired it TWICE, and the call itself takes ~4 s because it is an aggregate over
// the whole account - a statistics roll-up, which is not what a list needs.
//
// Two things happen here. Simultaneous callers share ONE in-flight promise, which removes the
// duplicate call outright. And the result is held briefly, so moving between the dashboards costs
// nothing at all.
//
// What this does NOT fix: the aggregate is still ~4 s on a cold load. That is a server-side
// measurement and a server-side fix, and calling this "solved" would repeat the mistake CLAUDE.md
// §8b already records - a plaster that hides the real number behind a green result.

const TTL_MS = 30000;

let cached = null;
let cachedAt = 0;
let inflight = null;

export function loadHomeSummary() {
  const fresh = cached && Date.now() - cachedAt < TTL_MS;
  if (fresh) return Promise.resolve(cached);
  if (inflight) return inflight;

  inflight = api.getHomeSummary()
    .then((d) => { cached = d; cachedAt = Date.now(); inflight = null; return d; })
    .catch((e) => { inflight = null; throw e; });
  return inflight;
}

// Anything done inside a project can change these numbers, so leaving one drops the cache and the
// next dashboard load is honest. Cheaper and far more predictable than guessing a TTL that is
// short enough to be correct.
export function invalidateHomeSummary() {
  cached = null;
  cachedAt = 0;
}